import { Typography, Divider, List, Card } from "antd";
import { StyledPrivacyPolicy } from "./styles";
import { APP_EMAIL } from "../../../utils/AiService/constant";

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <StyledPrivacyPolicy>
      <div className="privacy-container">
        <Card className="privacy-card">
          <Title level={2} className="privacy-title">
            Privacy Policy
          </Title>
          <Text className="last-updated">Last updated: February 2026</Text>
          <Divider />

          {/* 1 */}
          <section className="privacy-section">
            <Title level={4}>1. WHO WE ARE</Title>
            <Paragraph>
              Kelu ("Kelu", "we", "us", "our") is a company registered in
              England and Wales. We operate the website kelu.uk and the Kelu
              platform.
            </Paragraph>
            <Paragraph>
              <strong>Contact:</strong> {APP_EMAIL}
            </Paragraph>
          </section>

          {/* 2 */}
          <section className="privacy-section">
            <Title level={4}>2. WHAT DATA WE COLLECT</Title>

            <Paragraph strong>When you sign up:</Paragraph>
            <List
              dataSource={[
                "Name",
                "Email address",
                "Company name",
                "Password (encrypted)",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Paragraph strong style={{ marginTop: 16 }}>
              When you use the platform:
            </Paragraph>
            <List
              dataSource={[
                "Messages sent and received",
                "Conversation history",
                "Usage data (features used, login times)",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Paragraph strong style={{ marginTop: 16 }}>
              We do NOT currently collect:
            </Paragraph>
            <List
              dataSource={[
                "Payment information (handled by Stripe)",
                "Cookies beyond essential functionality",
                "Marketing data without your consent",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 3 */}
          <section className="privacy-section">
            <Title level={4}>3. WHY WE COLLECT IT</Title>
            <List
              dataSource={[
                "Provide and improve the Kelu service",
                "Send you important account notifications",
                "Comply with legal obligations",
                "Provide customer support",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 4 */}
          <section className="privacy-section">
            <Title level={4}>4. HOW WE STORE IT</Title>
            <List
              dataSource={[
                "All data is stored on UK/EU servers",
                "Data is encrypted in transit (SSL) and at rest",
                "We never sell your data to third parties",
                "Access is restricted to authorised Kelu team members only",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 5 */}
          <section className="privacy-section">
            <Title level={4}>5. HOW LONG WE KEEP IT</Title>
            <List
              dataSource={[
                "Account data: As long as your account is active",
                "After account deletion: 30 days, then permanently deleted",
                "Legal/financial records: 7 years (UK legal requirement)",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 6 */}
          <section className="privacy-section">
            <Title level={4}>6. YOUR RIGHTS UNDER UK GDPR</Title>
            <Paragraph>You have the right to:</Paragraph>
            <List
              dataSource={[
                "Access your personal data",
                "Correct inaccurate data",
                'Delete your data ("right to be forgotten")',
                "Export your data",
                "Object to processing",
                "Withdraw consent at any time",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
            <Paragraph>
              To exercise any of these rights, email:{" "}
              <strong>{APP_EMAIL}</strong>
            </Paragraph>
            <Paragraph>We will respond within 30 days.</Paragraph>
          </section>

          {/* 7 */}
          <section className="privacy-section">
            <Title level={4}>7. THIRD PARTY SERVICES</Title>
            <List
              dataSource={[
                "AWS (Amazon Web Services): Data hosting",
                "Stripe: Payment processing",
                "Sentry: Error monitoring",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
            <Paragraph>
              Each has their own privacy policy and GDPR compliance.
            </Paragraph>
          </section>

          {/* 8 */}
          <section className="privacy-section">
            <Title level={4}>8. CHILDREN'S PRIVACY</Title>
            <Paragraph>
              Kelu is not intended for users under 18. We do not knowingly
              collect data from children.
            </Paragraph>
          </section>

          {/* 9 */}
          <section className="privacy-section">
            <Title level={4}>9. CHANGES TO THIS POLICY</Title>
            <Paragraph>
              We may update this policy occasionally. We'll notify you by email
              of significant changes.
            </Paragraph>
          </section>

          {/* 10 */}
          <section className="privacy-section">
            <Title level={4}>10. COMPLAINTS</Title>
            <Paragraph>
              If you're unhappy with how we handle your data, you can complain
              to the Information Commissioner's Office (ICO):
            </Paragraph>
          </section>

          <Divider />
          <Paragraph>ico.org.uk | 0303 123 1113</Paragraph>
          <Paragraph>
            Questions? Email: <strong>{APP_EMAIL}</strong>
          </Paragraph>
        </Card>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default PrivacyPolicy;
